<template>
  <div>
    <!-- 筛选条件 -->
    <el-form :inline="true" :model="formInline" size="small" class="filter-form">
      <el-form-item label="时间范围">
        <el-date-picker
          v-model="formInline.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 250px;"
        />
      </el-form-item>
      <el-form-item label="仓库区域">
        <el-cascader
            v-model="formInline.warehouse"
            :options="warehouseList"
            :props="{ value: 'warehouse_kw_id', label: 'name', children: 'children' }"
            placeholder="选择区域"
            clearable
            style="width: 250px;"
          />
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input v-model="formInline.product_name" placeholder="请输入商品名称" style="width: 200px;" />
      </el-form-item>
      <!-- <el-form-item label="分类">
        <el-select v-model="formInline.category" placeholder="选择分类" clearable style="width: 150px;">
          <el-option
            v-for="item in categoryList"
            :key="item.category_id"
            :label="item.category_name"
            :value="item.category_id"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-form-item>
      <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onExport">导出</el-button>
               
            </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
      <el-table-column prop="product_name" label="商品名称" width="200" />
      <el-table-column prop="spec_value" label="规格" width="150" />
      <el-table-column prop="unit" label="单位" width="100" />
      <el-table-column prop="category_name" label="分类" width="150" />
      <el-table-column prop="beginning_inventory" label="期初库存"  />
      <el-table-column prop="inbound_quantity" label="入库数量"  />
      <el-table-column prop="outbound_quantity" label="出库数量"  />
      <el-table-column prop="ending_inventory" label="期末库存"  />
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
     </div>
  </div>
</template>
  
  <script>
    import ReportApi from '@/api/report.js';
    import WarehouseApi from '@/api/warehouse.js';
              import qs from 'qs'
  export default {
    components: {

    },
    data() {
      return {
        /*是否加载完成*/
        loading: false,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
   
        warehouse:[],
        formInline: {
        dateRange: [],
        warehouse: null,
        product_name: "",
        category: null,
      },
      warehouseList: [], // 仓库列表
      categoryList: [],  // 分类列表
      };
    },
    created() {
      this.getWarehouse();
      this.getTableList()
    },
  
    methods: {
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/report/exportCsales?' + qs.stringify(this.formInline);
      },
        /*搜索查询*/
        onSubmit() {
        let self = this
        self.tableData = [];
        self.curPage = 1
        self.getTableList();
      },
         // 重置筛选条件
      resetFilters() {
        this.formInline = {
          dateRange: [],
          category: null,
          warehouse: null,
          type: null,
        };
        this.curPage = 1;
        this.getTableList();
      },
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
       /*选择第几页*/
       handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
      getTableList(){
        let self = this;
        const params = {
            start_date: this.formInline.dateRange[0],
            end_date: this.formInline.dateRange[1],
            // category_id: this.formInline.category,
            warehouse_kw_id: this.formInline.warehouse,
            type: this.formInline.type,
            page: self.curPage,
            pageSize:  self.pageSize,
          };
        ReportApi.getInventoryFlow(params)
            .then((data) => {
              self.loading = false;
              self.tableData = data.data.list;
              self.totalDataNumber =  data.data.pagination.total

            })
            .catch((error) => {});
    },
         /*获取列表*/
         getWarehouse() {
          let self = this;
          WarehouseApi.list({}, true)
            .then(data => {
      
              self.warehouseList = data.data.list.data;

            })
            .catch(error => {
            });
      },
  
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/report/csales.vue